<h1 class="bv-security-page__title">{{ "changeMasterPassword" | i18n }}</h1>

<div class="bv-security-change-password">
  <app-web-change-password [inputPasswordFlow]="inputPasswordFlow"></app-web-change-password>
</div>

<!-- Passkey login hidden for Brackets Vault
<app-webauthn-login-settings class="bv-security-webauthn-settings"></app-webauthn-login-settings>
-->
